import React, { useEffect, useState } from "react";
import { notification, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import axios from "axios";
const PhotoGroupUpload = (props) => {
    const [api, contextHolder] = notification.useNotification();
    const [filedata, setfiledata] = useState(true);
    useEffect(() => {
        getFileUrl(props.fileid);
        resetphoto();
    }, [props.fileid]);
    const openNotificationWithIcon = (type) => {
        if (type === "success") {
            api["success"]({
                message: "刪除圖片",
                description: "成功刪除圖片",
            });
        } else {
            api["error"]({
                message: "刪除圖片",
                description: "刪除圖片失敗",
            });
        }
    };
    const delphoto = (fileid) => {
        axios
            .delete(`/shopping/api/mall/photo`, {
                data: { file: [{ file_id: fileid }] },
            })
            .then((response) => {
                setfiledata(null);
                openNotificationWithIcon(response.data.status);
            });
    };
    const getFileUrl = (tmp) => {
        axios
            .get(`/shopping/api/mall/photo?file_id=${tmp}`, { responseType: "blob" })
            .then((response) => {
                var blob_ = new Blob([response.data], {
                    type: "img/png",
                });
                const dataurl = URL.createObjectURL(blob_);
                setfiledata(dataurl);
            });
    };
    const resetphoto = () => {
        props.fileid &&
            props.fileid.forEach((tmp) =>
                tmp.file_id ? getFileUrl(tmp.file_id) : null
            );
    };
    const dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess("ok");
        }, 0);
    };
    const setPhoto = (info) => {
        let list = [];
        let formData = new FormData();
        formData.append(`file[0][inputFile]`, info.originFileObj);
        axios.post(`/shopping/api/mall/file`, formData).then((response) => {
            response.data &&
                response.data.file.forEach((tmp, i) => {
                    getFileUrl(tmp.file_id)
                    info["file_id"] = tmp.file_id;
                    info["status"] = "done";
                    list.push({ file_id: tmp.file_id });
                });
            props.srcdata(list)
        });
    };
    const uploadButton = (
        <div>
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                上傳
            </div>
        </div>
    );
    return (
        <>
            {contextHolder}
            <Upload
                accept="image/png, image/jpeg, image/jpg"
                customRequest={dummyRequest}
                listType="picture-card"
                maxCount={1}
                onRemove={(e) => delphoto(e.file_id)}
                onChange={(e) => setPhoto(e.file)}
                showUploadList={false}
            >
                {filedata ? (
                    <img
                        src={filedata}
                        alt="avatar"
                        style={{
                            width: '100%',
                        }}
                    />
                ) : (
                    uploadButton
                )}
            </Upload>
        </>
    );
};

export default PhotoGroupUpload;
